// Custom Music API Service
import axios from 'axios';

const API_BASE_URL = 'https://api.samasong.com/sama-music/'; // Production API base URL

// Custom Music API class
class MusicAPI {
  // Get all songs
  static async getAllSongs(page = 1, limit = 9999) {
    try {
      const response = await axios.get(`${API_BASE_URL}musics/getAll?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching songs:', error);
      throw error;
    }
  }

  // Get categories
  static async getCategories() {
    try {
      const response = await axios.get(`${API_BASE_URL}categories/getAll`);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  }

  // Get songs by category
  static async getSongsByCategory(categoryId) {
    try {
      const response = await axios.get(`${API_BASE_URL}musics/getAll?page=1&limit=9999&categoryId=${categoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching songs by category:', error);
      throw error;
    }
  }

  // Get subcategories by category ID
  static async getSubCategories(categoryId) {
    try {
      const response = await axios.get(`${API_BASE_URL}subCategories/getAll?categoryId=${categoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      throw error;
    }
  }

  // Get songs by subcategory
  static async getSongsBySubCategory(subCategoryId) {
    try {
      const response = await axios.get(`${API_BASE_URL}musics/getAll?page=1&limit=9999&subCategoryId=${subCategoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching songs by subcategory:', error);
      throw error;
    }
  }

  // Get songs by singer/artist
  static async getSongsBySinger(singerName) {
    try {
      const response = await axios.get(`${API_BASE_URL}musics/getAll?page=1&limit=9999&singer=${encodeURIComponent(singerName)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching songs by singer:', error);
      throw error;
    }
  }

  // Get all unique singers/artists
  static async getAllSingers() {
    try {
      const response = await axios.get(`${API_BASE_URL}musics/getAll?page=1&limit=9999`);
      // Extract unique singers from the response
      const songs = response.data.data || response.data || [];
      const uniqueSingers = [...new Set(songs.map(song => song.singer).filter(Boolean))];
      return uniqueSingers.sort();
    } catch (error) {
      console.error('Error fetching singers:', error);
      throw error;
    }
  }
}

export default MusicAPI;